import React, { useState } from 'react';
import PageBanner from '../components/PageBanner';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
import { SITE } from '../data/mock';
import { useToast } from '../hooks/use-toast';

const Contact = () => {
  const { toast } = useToast();
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sending, setSending] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    setSending(true);
    const subject = encodeURIComponent(form.subject || `Website enquiry from ${form.name}`);
    const body = encodeURIComponent(
      `Name: ${form.name}\nEmail: ${form.email}\n\n${form.message}`
    );
    const mailto = `mailto:info@molebohengmatlifoundation.org.za?subject=${subject}&body=${body}`;
    window.location.href = mailto;
    setTimeout(() => {
      setSending(false);
      toast({ title: 'Opening your email client', description: 'Your message is ready to send to info@molebohengmatlifoundation.org.za.' });
      setForm({ name: '', email: '', subject: '', message: '' });
    }, 800);
  };

  return (
    <main>
      <PageBanner title="Get In Touch" crumb="Contact" />

      <section className="py-20 md:py-24 bg-white">
        <div className="max-w-[1200px] mx-auto px-6 grid grid-cols-1 lg:grid-cols-3 gap-7 mb-14">
          {[
            { I: MapPin, title: 'Visit Us', lines: ['Woodmead Country Club Estate', '21 Woodlands Drive, Woodmead', 'Sandton 2196, Johannesburg'] },
            { I: Mail, title: 'Email Us', lines: [SITE.email, 'Ayesp@molebohengmatlifoundation.org.za', 'Media@molebohengmatlifoundation.org.za'] },
            { I: Phone, title: 'Call Us', lines: [SITE.phone, SITE.phoneAlt] },
          ].map((c, i) => (
            <div key={i} className="bg-slate-50 p-8 rounded-sm text-center card-lift">
              <div className="w-16 h-16 mx-auto rounded-full bg-[#F97559] text-white grid place-items-center">
                <c.I size={22} />
              </div>
              <h3 className="heading-display mt-5 text-xl font-bold text-slate-900">{c.title}</h3>
              {c.lines.map((l, j) => (
                <p key={j} className="mt-1 text-slate-600 text-sm break-all">{l}</p>
              ))}
            </div>
          ))}
        </div>

        <div className="max-w-[1200px] mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
          <div className="order-2 lg:order-1">
            <p className="uppercase text-sm tracking-[0.25em] text-slate-500 mb-3">Send a Message</p>
            <h2 className="heading-display text-3xl md:text-4xl font-bold text-slate-900 mb-7">We&rsquo;d love to hear from you</h2>
            <form onSubmit={submit} className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <input required value={form.name} onChange={(e)=>setForm({...form,name:e.target.value})} placeholder="Your Name" className="px-4 py-3.5 border border-slate-200 rounded-sm focus:outline-none focus:border-[#F97559] text-sm w-full" />
                <input required type="email" value={form.email} onChange={(e)=>setForm({...form,email:e.target.value})} placeholder="Your Email" className="px-4 py-3.5 border border-slate-200 rounded-sm focus:outline-none focus:border-[#F97559] text-sm w-full" />
              </div>
              <input value={form.subject} onChange={(e)=>setForm({...form,subject:e.target.value})} placeholder="Subject" className="w-full px-4 py-3.5 border border-slate-200 rounded-sm focus:outline-none focus:border-[#F97559] text-sm" />
              <textarea required rows={6} value={form.message} onChange={(e)=>setForm({...form,message:e.target.value})} placeholder="Write a message..." className="w-full px-4 py-3.5 border border-slate-200 rounded-sm focus:outline-none focus:border-[#F97559] text-sm resize-none" />
              <button disabled={sending} type="submit" className="inline-flex items-center gap-2 bg-[#F97559] hover:bg-[#e65a40] text-white font-semibold px-7 py-3.5 rounded-sm transition-colors disabled:opacity-60">
                {sending ? 'Sending...' : (<><Send size={16} /> Send Message</>)}
              </button>
            </form>
          </div>
          <div className="order-1 lg:order-2 h-[420px] md:h-[520px] rounded-sm overflow-hidden shadow-lg">
            <iframe
              title="map"
              className="w-full h-full border-0"
              src="https://maps.google.com/maps?q=Woodmead%20Country%20Club%20Estate%2C%2021%20Woodlands%20Drive%2C%20Woodmead%2C%20Sandton%202196%2C%20Johannesburg%2C%20South%20Africa&t=m&z=15&output=embed&iwloc=near"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;
